import styles from './ContentSpacer.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { isSearchResultsPath } from '@seek/seek-jobs-seo';
import classnames from 'classnames';

const mapStateToProps = () => createSelector(
  state => state.dashboard.expand,
  state => state.location.isHomepage,
  state => state.location.pathname,
  state => state.search.activeRefinement,

  (dashboardExpand, isHomepage, pathname, activeRefinement) => ({
    dashboardExpand,
    isHomepage,
    pathname,
    activeRefinement
  })
);
@connect(mapStateToProps)
export default class ContentSpacer extends Component {

  static propTypes = {
    dashboardExpand: PropTypes.bool.isRequired,
    isHomepage: PropTypes.bool.isRequired,
    pathname: PropTypes.string.isRequired,
    activeRefinement: PropTypes.string
  };

  render() {
    const {
      dashboardExpand,
      isHomepage,
      pathname,
      activeRefinement
    } = this.props;

    const isSearchPage = isSearchResultsPath(pathname);
    const rootClasses = classnames({
      [styles.root]: true,
      [styles.dashboard_isOpen]: dashboardExpand && isHomepage,
      [styles.worktype_isOpen]: isSearchPage && activeRefinement === 'WorkType',
      [styles.salary_isOpen]: isSearchPage && (activeRefinement === 'SalaryFrom' || activeRefinement === 'SalaryTo'),
      [styles.datelisted_isOpen]: isSearchPage && activeRefinement === 'DateListed',
      [styles.searchbar_isExpanded]: isHomepage,
      [styles.searchbar_isCollapsed]: isSearchPage
    });

    return <div className={rootClasses} />;
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/ContentSpacer/ContentSpacer.js
 **/